const values = [
  {
    src: "light.png",
    alt: "Being the Light",
    title: "Being the Light",
    description: "To All Stakeholders",
  },
  {
    src: "enrich.png",
    alt: "Enrich Customer Values",
    title: "Enrich Customer Values",
    description: "Services Satisfaction",
  },
  {
    src: "excelent.png",
    alt: "Strive For Excellent",
    title: "Strive For Excellent",
    description: "Enterprise Grade",
  },
  {
    src: "thrust.png",
    alt: "Thrust Forward The Change",
    title: "Thrust Forward The Change",
    description: "Latest Technologies",
  },
];

export default function CompanyValues() {
  return (
    <div className="absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-primary text-white py-10 w-[95vw] sm:py-5 xs:mt-50">
      <div className="grid grid-cols-4 md:grid-cols-2 lg:grid-cols-4 gap-4 mx-6">
        {values.map((value, index) => (
          <div className="flex justify-start items-center" key={index}>
            <div className="mx-auto md:mx-0 min-w-[3.75rem] min-h-[2.875rem]">
              <img src={value.src} alt={value.alt} />
            </div>
            <div className="px-4 hidden md:block">
              <h2 className="text-xl xs:text-lg sm:text-xl md:text-2xl font-semibold">
                {value.title}
              </h2>
              <p className="text-sm xs:text-base sm:text-lg">
                {value.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
